import { z } from "zod";
import { cautionStatusSchema } from "./caution-status.js";
export const listCautionsQuerySchema = z.object({
    status: cautionStatusSchema.optional(),
    search: z.string().trim().min(1).optional(),
});
